import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import cn from '#/utils/classnames'
import styles from './styles.module.scss'

interface BannerAdProps {
  redirectUrl: string
  className?: string
  width: number
  height: number
}

const BannerAd: React.FC<BannerAdProps> = ({ redirectUrl, className, width, height }) => (
  <div className={cn(styles['th-section'], styles['th-banner-section'], className)}>
    <Link href={redirectUrl} rel='noopener noreferrer' target='_blank'>
      <div className={styles['th-banner-content']}>
        <Image
          alt='Malobo Banner'
          className={styles['th-banner-image']}
          height={height}
          priority
          src='/images/malobo/banner-1.jpg'
          width={width}
        />
        <Image
          alt='Malobo Banner Square'
          className={styles['th-banner-image-square']}
          height={height}
          priority
          src='/images/malobo/banner-1-square.jpg'
          width={width}
        />
      </div>
    </Link>
  </div>
)

export default BannerAd
